import { useState } from 'react';
import { faqData } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-6 md:px-10 py-20">
      <div className="text-center mb-12">
        <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">FAQ</p>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
          常见问题
        </h2>
        <p className="mt-3 text-foreground-500 text-sm max-w-xl mx-auto">
          关于校园春色，你可能想了解的一些事情
        </p>
      </div>
      <div className="max-w-3xl mx-auto flex flex-col gap-4">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className="rounded-lg border border-background-200/70 overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
            >
              <h3 className="font-heading text-sm md:text-base font-medium text-foreground-800 pr-4">
                {faq.question}
              </h3>
              <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                openIndex === index ? 'rotate-180' : ''
              }`}>
                <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
              </div>
            </button>
            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}